const header = document.querySelector('.header')

window.addEventListener('scroll' , ()=> {
  console.log(window.scrollY);
  setTimeout(()=> {
    if(window.scrollY > 600) {
      header.style.transform = 'translateY(-100px)'
      header.classList.add('is-fixed')
      header.style.transform = 'translateY(0px)'
    } else {
      header.classList.remove('is-fixed')
    }
  },500)
})